import {
    USUARIOS_CLEAN_ERRORS,
  } from './constants';
  export function cleanErrors() {
    return (dispatch) => { 
      dispatch({
        type: USUARIOS_CLEAN_ERRORS
      });
  }}
  
  export function reducer(state, action) {
    if (action.type === USUARIOS_CLEAN_ERRORS) {
        // Just after a request is sent
        return {
          ...state,
          updateUserPhoneNumberPending: false,
          updateUserPhoneNumberError: null,
          updateUserPasswordPending: false,
          updateUserPasswordError: null,
        }
    }
    else {
        return state;
    }
  }
  